import { Dispatch, SetStateAction, useMemo, useState } from 'react';
import { SeriesItemData } from '../../../../../components/blackrock/advisor-center/cards/series-item-card/SeriesItemCardProps.ts';

/**
 * Custom hook to handle selected Tab and filter SeriesItemData list by tab (second tab topic).
 * @param {SeriesItemData[]} list - The series item list to filter by tab.
 * @param {string | undefined | null} secondTabTopic - The second tab topic to filter list for the second tab.
 * @returns {SeriesItemData[]} tabbedList - The item list for the selected tab.
 * @returns {number} selectedTab - The selected tab index.
 * @returns {Dispatch<SetStateAction<number>>} setSelectedTab - Function to set selected tab index.
 */
export const useTab = (
	list: SeriesItemData[],
	secondTabTopic: string | undefined | null
): [SeriesItemData[], number, Dispatch<SetStateAction<number>>] => {
	const [selectedTab, setSelectedTab] = useState<number>(0);

	const tabbedList = useMemo(
		() => getTabbedList(list, selectedTab, secondTabTopic),
		[selectedTab, list]
	);

	return [tabbedList, selectedTab, setSelectedTab];
};

const getTabbedList = (
	list: SeriesItemData[],
	selectedTab: number,
	secondTabTopic: string | null | undefined
): SeriesItemData[] => {
	if (selectedTab === 0) {
		return [...list];
	} else {
		const topic = typeof secondTabTopic === 'string' ? secondTabTopic : '';
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		return list.filter((item) => item.topics.includes(topic));
	}
};
